<script setup>
import { onMounted } from 'vue';
import DashboardView from './components/DashboardView.vue';
import LoginForm from './components/LoginForm.vue';
import 'primeicons/primeicons.css';
import Toast from 'primevue/toast'
import { useAuth } from './composables/useAuth';
import { useCurrentUser } from './composables/useCurrentUser';
import { authAPI } from './service/api.js';

const { isAuthenticated, logout } = useAuth();
const { currentUser, set: setCurrentUser } = useCurrentUser();

// On reload, the token survives in localStorage but the user state lives in
// memory only. Rehydrate via /me so role-gated UI knows what to show. If the
// token is invalid or expired, /me returns 401 and the api interceptor logs
// us out automatically.
onMounted(async () => {
  if (isAuthenticated.value && !currentUser.value) {
    try {
      const response = await authAPI.me();
      setCurrentUser(response.data);
    } catch (e) {
      // 401 path is handled by the api interceptor (auto-logout).
      // Anything else (network, 5xx) — clear the broken session so the
      // user sees the login screen and can retry cleanly.
      if (e?.message !== 'Unauthorized') {
        console.error('Failed to rehydrate current user:', e);
        logout();
      }
    }
  }
});
</script>
<template>
  <div id="app">
  <Toast position="top-right" />
  <DashboardView v-if="isAuthenticated" />
  <LoginForm v-else />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
